module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/shape/shapespritemobile-f20778.svg";